import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PATHS } from './paths';

const RequireAuth = ({ children }) => {
  const location = useLocation();
  const token = typeof window !== 'undefined' ? window.localStorage.getItem('accessToken') : null;

  if (!token) {
    const fromPath = `${location.pathname}${location.search}${location.hash}` || PATHS.root;
    return (
      <Navigate
        to={PATHS.login}
        replace
        state={{ from: fromPath }}
      />
    );
  }

  return <>{children}</>;
};

export default RequireAuth;

